import { Skeleton } from "@/components/ui/feedback/skeleton";

export function FullPageSkeleton() {
  return (
    <div className="min-h-[100svh] flex items-center justify-center">
      <div className="space-y-4 w-full max-w-md p-8">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-8 w-3/4" />
      </div>
    </div>
  );
}
